import React, { useEffect, useState } from 'react';
import { apiAssetUrl } from '../utils/apiAssetUrl';
import { personInitials } from '../utils/personInitials';
import './UserAvatar.css';

/**
 * A person's avatar, everywhere in the app: their profile photo once they have
 * uploaded one, their initials until then (or if the photo will not load).
 *
 * `person` is whatever object the page has for them. The photo is read from
 * `photo_url` (users rows), `photoUrl` (camelCase payloads) or `photo` (the
 * hallway sign's host list), all API-relative paths. `fallbackSrc` is a full URL
 * to try when they have no photo of their own, such as a MatchPlay avatar.
 *
 * Size, colours and border come from the caller's `className`, so each place
 * keeps its own look; this component owns the shape, the cropping and the
 * fallback. Pass `size` for a quick fixed size without a class.
 */
function UserAvatar({ person, className = '', size, fallbackSrc, style }) {
  const own = apiAssetUrl(person?.photo_url || person?.photoUrl || person?.photo || null);
  const src = own || fallbackSrc || null;
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);

  const sized = size ? { width: size, height: size, fontSize: Math.round(size * 0.38) } : null;

  return (
    <span className={`user-avatar ${className}`.trim()} style={{ ...sized, ...style }} aria-hidden="true">
      {src && !failed
        ? <img className="user-avatar__photo" src={src} alt="" onError={() => setFailed(true)} />
        : personInitials(person)}
    </span>
  );
}

export default UserAvatar;
